import { render, staticRenderFns } from "./SuperAdminCompanySettings.vue?vue&type=template&id=00c44a16&scoped=true"
import script from "./SuperAdminCompanySettings.vue?vue&type=script&lang=js"
export * from "./SuperAdminCompanySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c44a16",
  null
  
)

export default component.exports